import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import baseURL from "../../url";

import "./AjusteInventarioData.css";

export default function AjusteInventarioData() {

    const [ajustes, setAjustes] = useState([]);
    const [productos, setProductos] = useState([]);

    const [busqueda, setBusqueda] = useState("");
    const [resultados, setResultados] = useState([]);
    const [mostrarLista, setMostrarLista] = useState(false);

    const [productoSeleccionado, setProductoSeleccionado] = useState(null);

    const [movimientos, setMovimientos] = useState([]);
    const [stockActual, setStockActual] = useState(0);

    const [form, setForm] = useState({
        idProductoInventario: "",
        tipo: "entrada",
        cantidad: "",
        descripcion: "",
        referencia: ""
    });

    // ===================== GET AJUSTES =====================
    const cargarAjustes = () => {
        fetch(`${baseURL}/ajusteinventarioget.php`)
            .then(res => res.json())
            .then(data => {
                setAjustes(Array.isArray(data?.ajustes) ? data.ajustes : []);
            })
            .catch(err => {
                console.error(err);
                toast.error("Error cargando ajustes");
            });
    };

    // ===================== GET PRODUCTOS =====================
    const cargarProductos = () => {
        fetch(`${baseURL}/ajusteinventarioproductosget.php`)
            .then(res => res.json())
            .then(data => {
                setProductos(data?.productos || []);
            })
            .catch(err => console.error(err));
    };

    // ===================== MOVIMIENTOS =====================
    const cargarMovimientos = async (idProductoInventario) => {

        try {

            const res = await fetch(
                `${baseURL}/ajusteinventarioget.php?idProductoInventario=${idProductoInventario}`
            );

            const data = await res.json();

            setMovimientos(data?.ajustes || []);

            // NO actualizar stock aquí
            // el stock solo se actualiza desde handleSubmit o backend

        } catch (err) {
            console.error(err);
            toast.error("Error cargando movimientos");
        }
    };

    useEffect(() => {
        cargarAjustes();
        cargarProductos();
    }, []);

    // ===================== BUSCAR =====================
    const handleBuscar = (text) => {

        setBusqueda(text);
        setProductoSeleccionado(null);
        setMovimientos([]);

        if (!text || text.trim().length < 2) {
            setResultados([]);
            setMostrarLista(false);
            return;
        }

        const filtrados = productos.filter(p =>
            p?.nombre?.toLowerCase().includes(text.toLowerCase())
        );

        setResultados(filtrados);
        setMostrarLista(true);
    };

    // ===================== SELECCIONAR =====================
    const seleccionarProducto = (p) => {

        setProductoSeleccionado(p);

        setStockActual(Number(p.stock || 0));

        setForm(prev => ({
            ...prev,
            idProductoInventario: p.idProductoInventario
        }));

        setBusqueda(p.nombre);
        setResultados([]);
        setMostrarLista(false);

        cargarMovimientos(p.idProductoInventario);
    };

    // ===================== GUARDAR =====================
    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!form.idProductoInventario) {
            toast.error("Seleccione un producto");
            return;
        }

        if (!form.cantidad || Number(form.cantidad) <= 0) {
            toast.error("Cantidad inválida");
            return;
        }

        try {

            const res = await fetch(`${baseURL}/ajusteinventariopost.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ...form,
                    cantidad: Number(form.cantidad)
                })
            });

            const data = await res.json();

            if (data?.error) {
                toast.error(data.error);
                return;
            }

            if (data?.nuevoStock !== undefined) {
                setStockActual(Number(data.nuevoStock));

                const nuevo = Number(data.nuevoStock);

                // 1. stock principal
                setStockActual(nuevo);

                // 2. producto seleccionado
                setProductoSeleccionado(prev => ({
                    ...prev,
                    stock: nuevo
                }));

                // 3. productos base
                setProductos(prev =>
                    prev.map(p =>
                        Number(p.idProductoInventario) === Number(form.idProductoInventario)
                            ? { ...p, stock: nuevo }
                            : p
                    )
                );

                // 4. 🔥 RESULTADOS DE BÚSQUEDA (ESTO TE FALTABA)
                setResultados(prev =>
                    prev.map(p =>
                        Number(p.idProductoInventario) === Number(form.idProductoInventario)
                            ? { ...p, stock: nuevo }
                            : p
                    )
                );
            }

            toast.success("Ajuste registrado");

            setForm({
                idProductoInventario: form.idProductoInventario,
                tipo: "entrada",
                cantidad: "",
                descripcion: "",
                referencia: ""
            });

            cargarAjustes();
            cargarMovimientos(form.idProductoInventario);

        } catch (err) {
            console.error(err);
            toast.error("Error servidor");
        }
    };

    return (

        <div className="main-content">



            {/* SEARCH */}
            <div className="search-wrapper">

                <input
                    className="search-input"
                    placeholder="Buscar producto..."
                    value={busqueda}
                    onChange={(e) => handleBuscar(e.target.value)}
                    onFocus={() => resultados.length > 0 && setMostrarLista(true)}
                />

                {mostrarLista && resultados.length > 0 && (

                    <div className="resultados-box">

                        {resultados.map(p => (

                            <div
                                key={p.idProductoInventario}
                                className="resultado-item"
                                onClick={() => seleccionarProducto(p)}
                            >

                                {p.imagen ? (
                                    <img
                                        src={p.imagen}
                                        className="resultado-img"
                                        alt="producto"
                                    />
                                ) : (
                                    <div className="resultado-placeholder">
                                        Sin Img
                                    </div>
                                )}

                                <div className="resultado-info">
                                    <div className="resultado-nombre">
                                        {p.nombre}
                                    </div>
                                    <div className="resultado-stock">
                                        Stock: {p.stock}
                                    </div>
                                </div>

                            </div>

                        ))}

                    </div>

                )}

            </div>

            {/* PRODUCTO SELECCIONADO */}
            {productoSeleccionado && (

                <div className="producto-seleccionado">

                    {productoSeleccionado.imagen ? (
                        <img
                            src={productoSeleccionado.imagen}
                            className="producto-seleccionado-img"
                        />
                    ) : (
                        <div className="producto-seleccionado-placeholder">
                            Sin Img
                        </div>
                    )}

                    <div className="producto-seleccionado-info">

                        <h4>{productoSeleccionado.nombre}</h4>

                        <p>
                            Stock actual:
                            <strong> {stockActual}</strong>
                        </p>

                    </div>

                </div>

            )}

            {/* FORM */}
            {productoSeleccionado && (

                <form onSubmit={handleSubmit} className="form-inline">

                    <select
                        className="input-inline"
                        value={form.tipo}
                        onChange={(e) =>
                            setForm({ ...form, tipo: e.target.value })
                        }
                    >
                        <option value="entrada">Entrada</option>
                        <option value="salida">Salida</option>
                    </select>

                    <input
                        className="input-inline"
                        type="number"
                        placeholder="Cantidad"
                        value={form.cantidad}
                        onChange={(e) =>
                            setForm({ ...form, cantidad: e.target.value })
                        }
                    />

                    <input
                        className="input-inline"
                        placeholder="Descripción"
                        value={form.descripcion}
                        onChange={(e) =>
                            setForm({ ...form, descripcion: e.target.value })
                        }
                    />

                    <input
                        className="input-inline"
                        placeholder="Referencia"
                        value={form.referencia}
                        onChange={(e) =>
                            setForm({ ...form, referencia: e.target.value })
                        }
                    />

                    <button className="btnGuardarAjuste">
                        Guardar
                    </button>

                </form>

            )}

            {/* MOVIMIENTOS */}
            {productoSeleccionado && (

                <div className="movimientos-container">

                    <h3>Historial de movimientos</h3>

                    {movimientos.length === 0 ? (

                        <p>No existen movimientos.</p>

                    ) : (

                        <table className="tabla">

                            <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>Tipo</th>
                                    <th>Cantidad</th>
                                    <th>Descripción</th>
                                    <th>Referencia</th>
                                </tr>
                            </thead>

                            <tbody>

                                {movimientos.map(m => (

                                    <tr key={m.idAjuste}>

                                        <td>{m.createdAt}</td>

                                        <td>
                                            <span className={
                                                m.tipo === "entrada"
                                                    ? "badge-entrada"
                                                    : "badge-salida"
                                            }>
                                                {m.tipo}
                                            </span>
                                        </td>

                                        <td>{m.cantidad}</td>
                                        <td>{m.descripcion}</td>
                                        <td>{m.referencia}</td>

                                    </tr>

                                ))}

                            </tbody>

                        </table>

                    )}

                </div>

            )}



        </div>

    );
}